import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { useCustomer } from "../lib/auth";
import { apiErr } from "../lib/api";

export default function AuthSheet() {
  const { authOpen, setAuthOpen, login, register } = useCustomer();
  const [mode, setMode] = useState("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  if (!authOpen) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "signin") await login(email, password);
      else await register({ email, password, name });
      toast.success("Welcome to PurohithConnect");
      setAuthOpen(false);
    } catch (err) {
      toast.error(apiErr(err, "Could not sign in"));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 sm:items-center" data-testid="cust-auth-sheet">
      <div className="w-full max-w-[440px] rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-3xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="font-heading text-xl text-[#2A211C]">{mode === "signin" ? "Welcome back" : "Create account"}</h3>
          <button onClick={() => setAuthOpen(false)} data-testid="cust-auth-close" className="rounded-full p-1.5 text-[#7A6E64] hover:bg-[#F3EBDE]"><X size={18} /></button>
        </div>
        <div className="mb-4 flex rounded-full bg-[#F3EBDE] p-1 text-sm">
          {["signin", "signup"].map((m) => (
            <button key={m} onClick={() => setMode(m)} data-testid={`cust-auth-tab-${m}`}
              className={`flex-1 rounded-full py-1.5 font-medium ${mode === m ? "bg-[#8B1A2B] text-white" : "text-[#7A6E64]"}`}>
              {m === "signin" ? "Sign in" : "Create account"}
            </button>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-3">
          {mode === "signup" && (
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="cust-auth-name"
              className="w-full rounded-xl border border-[#E4D8C7] bg-[#FBF6EF] px-4 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
          )}
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" data-testid="cust-auth-email"
            className="w-full rounded-xl border border-[#E4D8C7] bg-[#FBF6EF] px-4 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="cust-auth-password"
            className="w-full rounded-xl border border-[#E4D8C7] bg-[#FBF6EF] px-4 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
          <button type="submit" disabled={busy} data-testid="cust-auth-submit"
            className="w-full rounded-xl bg-[#8B1A2B] py-3 font-semibold text-white transition hover:bg-[#6F1420] disabled:opacity-60">
            {busy ? "Please wait…" : mode === "signin" ? "Sign in" : "Create account"}
          </button>
        </form>
        <p className="mt-3 text-center text-xs text-[#A0968A]">Demo: customer@demo.in · customer123</p>
      </div>
    </div>
  );
}
